export default __webpack_public_path__ + "assets/complete-solution.71866bf0.svg";